/*!
 * Select de usuarios de empresa por empresa
 */

;(function ( $, window, document, undefined ) {

    // Create the defaults once
    var pluginName = 'beUserByCompany',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;

        this.options = $.extend( {}, defaults, options) ;
        
        this._defaults = defaults;
        this._name = pluginName;
        
        this.init();
    }

    Plugin.prototype.init = function () {
        
        Plugin = this;
        
        Plugin.company = $(Plugin.element).find('.js-master--company');
        Plugin.companyUsers = $(Plugin.element).find('.js-master--company-users');
        
        Plugin.company.on('change',function(){
        
            Plugin.setCompanyUsersSelect(Plugin.company.val());
        });

        $('.js--generatePass').on('click',function(){
            Plugin.getPass($(this).attr('data-id'));
        });
        $('#copyPass').on('click',function(){
            $('#temporary').select();
            document.execCommand("copy");
            Plugin.setTooltip('Copiado', this);
            Plugin.hideTool(this);

        });

        $('.js--generateRecoveryLink').on('click',function(){
            Plugin.getRecoveryLink($(this).attr('data-id'));
        });
        $('#copyRecovery').on('click',function(){
            $('#temporaryLink').select();
            document.execCommand("copy");
            Plugin.setTooltip('Copiado', this);
            Plugin.hideTool(this);

      });
    };
    
    Plugin.prototype.setCompanyUsersSelect = function(companyId){
      Plugin.companyUsers.select2({
            allowClear: true,
            ajax: {
                url: window.location.origin+'/empresas/'+companyId+'/users/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.first_name + ' ' + item.last_name,
                                    slug: item.first_name + ' ' + item.last_name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.first_name + ' ' + item.last_name,
                                    slug: item.first_name + ' ' + item.last_name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });  
    };

    Plugin.prototype.showMessage= function(data){
        $('#PassMessage').removeClass('hide');
        $('#PassMessage > span').text(data);
    };

    Plugin.prototype.setTooltip = function(message, currentElement) {
        var id = '#' + currentElement.id;

        $(id).tooltip('enable')
          .attr('data-original-title', message)
          .tooltip('show');
    };

    Plugin.prototype.hideTool=function(currentElement){
        var id = '#' + currentElement.id;

        setTimeout(function() {
          $(id).tooltip('disable');
        }, 1000);
      };

    Plugin.prototype.getPass = function($id){

        var Plugin = this;

        $.ajax({
            url: window.location.origin + '/empresas/usuarios/temporary-password/' + $id,
            success : function(data){
                var obj=JSON.parse(data);
                console.log(obj);
                Plugin.printPass(obj.real_password);
                Plugin.showMessage(obj.expires_at);
            },
            error : function(data){
                console.info(data);
            }
        });
    };

    Plugin.prototype.getRecoveryLink = function($id){
        var Plugin = this;

        $.ajax({
          url: window.location.origin + '/empresas/usuarios/recovery-link/' + $id,
          success : function(data){
            Plugin.printRecoveryLink(data)
          },
          error : function(data){
            console.info(data);
          }
        });
}

    Plugin.prototype.printPass =function (data){
        $('.cointainerButtonCopy').removeClass('hide');
        $('.cointainerGeneratePass').addClass('hide');
        $('#temporary').focus();
        $('#temporary').val(data);
    };

    Plugin.prototype.printRecoveryLink = function(data) {
    $('.containerButtonCopyRecovery').removeClass('hide');
    $('.containerGenerateRecoveryLink').addClass('hide');
    $('#temporaryLink').focus();
    $('#temporaryLink').val(data);
}
    // A really lightweight plugin wrapper around the constructor, 
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, 
                new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );